import { render, staticRenderFns } from "./QDialog.vue?vue&type=template&id=0a8ae2f1&"
import script from "./QDialog.vue?vue&type=script&lang=js&"
export * from "./QDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports